<div
  style="height: 40px"
  class="sp-row__align sp-cursor__pointer sp-background__accent sp-border-radius__xs sp-padding__horiz"
  [mat-menu-trigger-for]="seller_details_tab_menu">
  <p class="sp-color__accent-contrast">{{ current_tab || '' | translate }}</p>
  <mat-icon class="sp-color__accent-contrast"> expand_more </mat-icon>
</div>

<mat-menu #seller_details_tab_menu="matMenu">
  <div
    *ngFor="let tab of getTabs()"
    (click)="onTabClick(tab)"
    class="sp-padding__x2 sp-cursor__pointer sp-row__align sp-margin__right">
    <mat-icon class="material-symbols-outlined"> {{ tab[0] }} </mat-icon>
    <span class="sp-margin__left"> {{ tab[1] | translate }} </span>
  </div>
</mat-menu>
